export const floatLabelPt = () => {
  return {
    root: {
      class: 'font-14-n'
    }
  }
}
